import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { VersionService } from './services/apps/version/version.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Modernize Angular Admin Tempplate';

  constructor(private readonly versionService: VersionService) {
    this.versionService.initialize();
  }
}
